/* Marca le copertine caricate (.g-ld): toglie il fondo grigio di attesa e fa partire la dissolvenza (g-media.css). */
(function () {
  'use strict';
  var SEL = 'img.giunti-card__image';
  function done(img) { if (!img.classList.contains('g-ld')) img.classList.add('g-ld'); }
  // load non risale il DOM: si ascolta in fase di cattura, anche per le schede aggiunte dopo (React, slider, scroll infinito)
  document.addEventListener('load', function (e) { var t = e.target; if (t && t.matches && t.matches(SEL)) done(t); }, true);
  document.addEventListener('error', function (e) { var t = e.target; if (t && t.matches && t.matches(SEL)) done(t); }, true);
  function sweep() { document.querySelectorAll(SEL + ':not(.g-ld)').forEach(function (img) { if (img.complete) done(img); }); }
  sweep();
  document.addEventListener('DOMContentLoaded', sweep);
})();
